/* AFIQ redesign: cart page (sections/afiq-cart-main.liquid). The section renders the real cart in Liquid; this file:
   - changes quantities / removes lines with /cart/change.js, then re-renders the section (Section Rendering API)
     and quietly refreshes Dawn's cart drawer markup + the header count (the drawer itself is not modified);
   - draws the upsell: no full system (Vol 1–4 or the Elite bundle) → "Complete the full system", with the extra cost
     estimated from the AFIQ_UI.priceDecks/cartItems route the button adds + the ladder on the cart's single decks; full system present → Flag 5v5 / Basics add-ons. Adds go through AFIQ_UI.addToCart. */
(function () {
  'use strict';
  var root = document.querySelector('[data-afiq-cart]');
  if (!root || !window.AFIQ_UI || !window.AFIQ) return;
  var U = window.AFIQ_UI, P = U.P, $ = U.$, esc = U.esc, VOLS = U.VOLS;
  var sid = root.getAttribute('data-section-id');
  var body = function () { return root.querySelector('[data-afiq-cart-body]'); };
  var bundles = ((U.D._meta || {}).bundles || []);

  var trust = document.querySelector('[data-afiq-trust]');
  if (trust) trust.outerHTML = U.trust();

  /* cart lines → decks. A bundle line counts as its decks (for "has the full system"), but it is priced as a
     bundle, so only single-deck lines count toward the ladder when estimating the extra cost. */
  var deckOf = function (v) { var hit = null; Object.keys(P).forEach(function (d) { if (P[d].variant === v) hit = d; }); return hit; };
  var bundleOf = function (v) { return bundles.filter(function (b) { return b.variant === v; })[0] || null; };
  function readCart() {
    var items = [], out = { all: [], single: [] };
    try { items = JSON.parse(body().querySelector('[data-afiq-cart-items]').textContent); } catch (e) {}
    items.forEach(function (it) {
      var d = deckOf(it.v), b = d ? null : bundleOf(it.v);
      for (var i = 0; i < it.q; i++) {
        if (d) { out.all.push(d); out.single.push(d); }
        else if (b) out.all = out.all.concat(b.decks.filter(function (x) { return P[x]; }));
      }
    });
    return out;
  }
  function cartDecks() { return readCart().all; }
  /* Ladder on single decks: same maths as afiq-shop.js (Shopify floors the discount per unit). */
  function ladderTotal(ids) {
    var n = ids.filter(function (d) { return P[d].ladder; }).length;
    return ids.reduce(function (s, d) { return s + (P[d].ladder ? AFIQ.unitCents(n, P[d].price) : P[d].price); }, 0);
  }
  /* Estimated extra cost of adding `ids` the way the button adds them (AFIQ_UI.cartItems → priceDecks route). */
  function extraFor(ids) {
    var single = readCart().single, addSingle = [], addBundles = 0;
    U.cartItems(ids, 'cart-upsell').forEach(function (it) {
      var d = deckOf(it.id), b = d ? null : bundleOf(it.id);
      for (var i = 0; i < it.quantity; i++) { if (d) addSingle.push(d); else if (b) addBundles += b.price; }
    });
    return addBundles + ladderTotal(single.concat(addSingle)) - ladderTotal(single);
  }

  function renderUpsell() {
    var box = body().querySelector('[data-el="upsell"]'); if (!box || VOLS.length < 4) return;
    var decks = cartDecks();
    var hasElite = VOLS.every(function (d) { return decks.indexOf(d) > -1; });
    var html = '';
    if (!hasElite) {
      /* Full-system offer = the drawer's upgrade (one source of truth): swap the cart's volumes or smaller set for the
         Elite bundle line, priced from Shopify's real line prices. Empty of volumes: add the Elite bundle outright. */
      var elite = (U.BUNDLES || []).filter(function (b) { return b.decks.length === 4; })[0];
      if (!decks.some(function (d) { return VOLS.indexOf(d) > -1; })) {
        html = elite ? '<div class="upsell">' + U.stack(VOLS) + '<div><b>Add the full system</b><small>All four volumes, 216 cards, ' + $(elite.price) + '.</small></div>' +
          '<button type="button" class="btn btn-red" data-up-elite="' + elite.variant + '" data-offer="full-system">Add all four</button></div>' : '';
      } else {
        box.innerHTML = '';
        /* the drawer boots on DOMContentLoaded, after this script: wait until <cart-drawer> is defined */
        customElements.whenDefined('cart-drawer').then(function () { var dr = document.querySelector('cart-drawer'); if (dr && dr.refresh && dr.upgradePlan) return dr.refresh().then(function (c) {
          var plan = c && dr.upgradePlan(c); box._plan = plan;
          if (!plan) return;
          box.innerHTML = '<div class="upsell">' + U.stack(VOLS) + '<div><b>Complete the full system</b><small>Swap ' + esc(plan.label) + ' for all four volumes (216 cards) for ' + $(plan.diff) +
            ' more.</small></div><button type="button" class="btn btn-red" data-up-swap data-offer="full-system">Upgrade · +' + $(plan.diff) + '</button></div>';
        }); });
        return;
      }
    } else {
      html = ['fl5', 'basics'].filter(function (d) { return P[d] && decks.indexOf(d) < 0; }).map(function (d) {
        var extra = extraFor([d]);
        return '<div class="upsell">' + U.stack([d]) + '<div><b>Add ' + (d === 'fl5' ? 'Flag Football IQ 5v5' : 'Football Basics') + '</b><small>' + esc(P[d].tag) + ' · about +' + $(extra) + '</small></div>' +
          '<button type="button" class="btn btn-line" data-up="' + d + '" data-offer="' + d + '">Add</button></div>';
      }).join('');
    }
    box.innerHTML = html;
  }

  /* re-render this section + the drawer markup, without opening the drawer */
  function refresh() {
    var b = body(); b.classList.add('busy');
    var hasDrawer = !!document.querySelector('cart-drawer');
    return fetch(location.pathname + '?sections=' + encodeURIComponent(sid) + (hasDrawer ? ',cart-drawer' : ''), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var parse = function (h) { return new DOMParser().parseFromString(h, 'text/html'); };
        var fresh = json[sid] && parse(json[sid]).querySelector('[data-afiq-cart-body]');
        if (fresh) b.replaceWith(fresh);
        var n = +((fresh || b).getAttribute('data-count') || 0);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && json['cart-drawer']) {
          var src = parse(json['cart-drawer']).querySelector('#CartDrawer'), dst = document.getElementById('CartDrawer');
          if (src && dst) dst.innerHTML = src.innerHTML;
          drawer.classList.toggle('is-empty', n === 0);
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          bubble.setAttribute('aria-label', 'Cart, ' + n + ' items');
          var c = bubble.querySelector('.cart-count');
          if (n > 0) { if (!c) { c = document.createElement('span'); c.className = 'cart-count'; c.setAttribute('aria-hidden', 'true'); bubble.appendChild(c); } c.textContent = n; }
          else if (c) c.remove();
        }
        renderUpsell();
      })
      .catch(function () { location.reload(); })
      .then(function () { var x = body(); if (x) x.classList.remove('busy'); });
  }

  function change(key, qty, focusSel) {
    body().classList.add('busy');
    fetch((window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not update your cart'); return d; }); })
      .then(function () { return refresh(); })
      .then(function () { var f = focusSel && root.querySelector(focusSel); if (f) f.focus(); })
      .catch(function (e) { alert(e.message); refresh(); });
  }

  root.addEventListener('click', function (e) {
    var q = e.target.closest('[data-q]');
    if (q) {
      e.preventDefault();
      var to = Math.max(0, +q.getAttribute('data-to'));
      var out = q.closest('.cline') && q.closest('.cline').querySelector('output');
      var dir = to > +(out ? out.textContent : 0) ? 1 : -1;
      var sel = to > 0 && q.tagName === 'BUTTON' ? 'button[data-q="' + q.getAttribute('data-q') + '"][data-to="' + (to + dir) + '"]' : null;
      change(q.getAttribute('data-q'), to, sel);
      return;
    }
    var sw = e.target.closest('[data-up-swap]');
    if (sw) {
      var dr = document.querySelector('cart-drawer'), box = body().querySelector('[data-el="upsell"]');
      if (dr && dr.upgrade && box && box._plan) {
        sw.disabled = true;
        U.track('afiq_cart_upsell', { offer: 'full-system-swap', extra: +(box._plan.diff / 100).toFixed(2) });
        var p = dr.upgrade(box._plan); /* tags b10x-upsell-cart-upgrade-full-system */
        if (p) p.then(function () { refresh(); });
      }
      return;
    }
    var ue = e.target.closest('[data-up-elite]');
    if (ue) {
      U.track('afiq_cart_upsell', { offer: 'full-system-add' });
      U.addToCart([{ id: +ue.getAttribute('data-up-elite'), quantity: 1 }], 'cart-upsell', ue).then(function () { if (U.tagUpsell) U.tagUpsell('b10x-upsell-cart-full-system'); });
      return;
    }
    var up = e.target.closest('[data-up]');
    if (up) {
      var ids = up.getAttribute('data-up').split(',').filter(function (d) { return P[d]; });
      if (!ids.length) return;
      U.track('afiq_cart_upsell', { offer: up.getAttribute('data-offer'), decks: ids.join(','), estimate: +(extraFor(ids) / 100).toFixed(2) });
      U.addToCart(U.cartItems(ids, 'cart-upsell'), 'cart-upsell', up).then(function () {
        if (U.tagUpsell) U.tagUpsell(ids.map(function (d) { return 'b10x-upsell-cart-' + ({ fl5: 'flag', basics: 'basics' }[d] || d); }));
      });
    }
  });

  /* AFIQ_UI.addToCart fires this on success (and has opened the drawer): stay on the cart page and re-render. */
  document.addEventListener('cart:refresh', function () {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function' && drawer.classList.contains('active')) drawer.close();
    refresh();
  });

  renderUpsell();
})();
